import * as React from "react";
import { observer } from "mobx-react";
import { FormControl, withStyles } from "@material-ui/core";
import Properties from "./Properties";
import CalculateProperties from "./CalculateProperties";
import BDIProperties from "./BdiProperties";
import { WBSPropertiesStore } from "modules/WBS/WBSPropertiesStore";
import { WBSStore } from "modules/WBS/WBSStore";
import { LoginStore } from "modules/login/LoginStore";

const styles = () => ({
  form: {
    display: "block",
    overflowX: "hidden" as any,
    overflowY: "scroll" as any,
  },
  propertiesGroup: {
    background: "#363637",
    padding: "15px 15px 0px 15px",
    marginBottom: 4,
  },
});

interface IProps {
  classes: any;
}

@observer
class WBSProperties extends React.Component<IProps> {
  constructor(props) {
    super(props);
  }

  handleCalculateChange(name: string, value: any) {
    WBSPropertiesStore.setWBSCalculate(name, value);
  }

  handleDateChange = (date: Date) => {
    this.updateWBS("baseMonth", date, "");
  };

  handleBdiChange(ev, value) {
    const name = ev.target.name;

    if (name) {
      const data = WBSPropertiesStore.getCurrentWBSBdi();
      if (data[name] === value) return;
      data[name] = value;

      this.updateWBS("bdi", data, "").then(() => {
        if (data.show) return WBSStore.changeDecimalAndRule();
        return WBSStore.changeDecimalAndRule();
      });
    }
  }

  handleProjectChange(ev, value) {
    const id = ev.target.id;
    const name = ev.target.name;

    this.updateWBS(name, value, id);
  }

  async updateWBS(name: string, value: any, id: string) {
    if (WBSPropertiesStore.WBSProjectDataModel) {
      if (name) WBSPropertiesStore.WBSProjectDataModel[name] = value;

      // Efetua a atualização das informações globais, após o término da Promise, dispara a verificação e
      // atualização das fórmulas se a informação global alterada estiver em uso no orçamento
      return WBSPropertiesStore.updateWBSProjectData().then(() =>
        WBSPropertiesStore.updateWBSProjectQuantitiesFromFormula(id)
      );
    }
  }

  render() {
    const { classes } = this.props;
    const { wbsCalculate, calculating } = WBSPropertiesStore;
    const wbsProject: any = WBSPropertiesStore.WBSProjectDataModel || {};
    const wbsBdi = WBSPropertiesStore.getCurrentWBSBdi();

    const baseDate = wbsProject.baseMonth || new Date();
    const project = {
      projectTerm: wbsProject.projectTerm,
      landArea: wbsProject.landArea,
      privateUnits: wbsProject.privateUnits,
      builtArea: wbsProject.builtArea,
      equivalentArea: wbsProject.equivalentArea,
      privateArea: wbsProject.privateArea,
    };

    const isTrial = LoginStore.isTrialUser();

    return (
      <FormControl
        className={classes.form}
        style={{ height: `calc(100vh - ${isTrial ? 103 : 68}px)` }}
      >
        <Properties
          containerClass={classes.propertiesGroup}
          data={{ baseDate, project }}
          onDateChange={(date) => this.handleDateChange(date)}
          onInputChange={(ev, value) => this.handleProjectChange(ev, value)}
        />
        <CalculateProperties
          containerClass={classes.propertiesGroup}
          decimalPlaces={wbsCalculate.decimalPlaces}
          roundingRule={wbsCalculate.roundingRule}
          calculating={calculating}
          onChange={(name, value) => this.handleCalculateChange(name, value)}
        />
        <BDIProperties
          containerClass={classes.propertiesGroup}
          data={wbsBdi}
          onChange={(ev, value) => this.handleBdiChange(ev, value)}
        />
      </FormControl>
    );
  }
}

export default withStyles(styles)(WBSProperties);



// WEBPACK FOOTER //
// ./src/modules/projectRightMenu/components/layouts/WBSProperties/index.tsx